import 'jquery-mask-plugin';

import CepSearch from '../cepSearch';
import InputMask from '../inputMask';

document.addEventListener('DOMContentLoaded', () => {
  const mainAddressForm = $('#main-address-form');

  CepSearch();
  InputMask();

  $('select#main-address').change(function () {
    mainAddressForm.submit();
  });
});



// WEBPACK FOOTER //
// /opt/atlassian/pipelines/agent/build/app/assets/javascripts/packs/auth/account/account.js